import {EntityBase} from "../../../shared/entity/EntityBase";

const TROPHY_CHALLENGE_GROUP_FIELDS = {
    seq: {type: Number, defaultValue: 0},
    memo: {defaultValue: ''},
    resourceIdx: {type: Number, defaultValue: 0},
    completeReward: {type: Array, defaultValue: []},
    minVersion: {defaultValue: '0.0.0'},
}

export class TrophyChallengeGroupEntity extends EntityBase {
    constructor(data = {}) {
        super(data, TROPHY_CHALLENGE_GROUP_FIELDS);

        if (Array.isArray(this.completeReward)) {
            this.completeReward = this.completeReward.map(Number).filter(n => !isNaN(n) && n > 0);
        } else if (typeof this.completeReward === 'string' && this.completeReward !== '') {
            this.completeReward = this.completeReward.split(',').map(Number).filter(n => !isNaN(n) && n > 0);
        }

        this.errors = [
            {condition: () => !/^\d+\.\d+\.\d+$/.test(this.minVersion), message: '최소 적용 버전이 잘못 작성되었습니다. (예: 1.0.0)'},
        ];
    }
}
